import React from 'react';
import { resizeImage } from '../../utils/images/imageResizer';
import { s3upload } from '../../utils/filesystem/fileUpload';
import { useAppContext } from '../../utils/context';

export function withImageUpload (WrappedComponent) {
	const ReturnedComponent = (props) => {
		const { filePath = 'product' } = props;
		const { getServerEndpoint } = useAppContext();

		// Accepts form data as input prior to submitting form
		// If image is supplied, resizes and uploads to s3, and returns
		// new form data containing image URL for submission.
		const preSubmitFunction = async ({ form, changeFormValue }) => {
			const { image } = form;

			let imageUrl;
			if (image) {
				// Resize the image if needed
				const processedFile = await resizeImage({ image, maxWidth: 500, maxHeight: 500 });

				// Upload to S3 and get the url
				imageUrl = await s3upload(processedFile, null, `images/${filePath}s/`, getServerEndpoint);
			}

			changeFormValue({ image: undefined, imageUrl }); // Could reset this would some better reset function?
		};

		return (
			// eslint-disable-next-line react/jsx-filename-extension
			<WrappedComponent
				preSubmitFunction={preSubmitFunction}
				{...props}
			/>
		);
	};
	return ReturnedComponent;
}
